import { ArticleTypeMap } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/maps/ArticleTypeMap';
import { FormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/FormItem';
import { MinimalFormItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/MinimalFormItem';
import { RequestItem } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/types/RequestItem';

export abstract class Item<T extends FormItem> {
  public price: number;
  public units: number;
  public vatRate: number;
  public totalPrice: number;
  public totalDiscount: number;
  public additionalData?: object;

  constructor(public readonly data: T, additionalData?: object) {
    this.price = parseFloat(data.price || '0');
    this.units = parseInt(data.units);
    this.vatRate = parseInt(data.vat) / 100;
    this.totalPrice = parseFloat(data.price || '0') * parseInt(data.units);
    this.totalDiscount = 0;

    // In the case of CheckoutSession Cart modification, this corresponds to
    // additional data that will not intervene in the Cart Form but should not be lost
    if (additionalData) {
      this.additionalData = additionalData;
    }
  }

  protected abstract isCompleted(): boolean;
  protected abstract toDto(): object;
  protected abstract toForm(): FormItem;

  public isItemCompleted(): boolean {
    return (
      !!this.data.type &&
      !!this.data.category &&
      !!this.data.description &&
      !!this.data.vat &&
      !!this.data.units &&
      !!parseInt(this.data.price) &&
      this.isCompleted()
    );
  }

  public toMinimalFormItem(): MinimalFormItem {
    const { type, category, description, vat, units, price } = this.data;
    return {
      type,
      category,
      description,
      vat,
      units,
      price,
    } as MinimalFormItem;
  }

  public toFormItem(): FormItem {
    return this.toForm();
  }

  public toItemDto(totalDiscount?: number) {
    if (totalDiscount) {
      this.totalDiscount = totalDiscount;
    }

    return {
      article: {
        type: ArticleTypeMap.toArticleTypeExternal(this.data.type),
        category: this.data.category,
        unitPriceWithTax: Math.round(this.price * 100) / 100,
        name: this.data.description?.trim() || '',
        reference: this.data.description?.trim() || '',
        description: this.data.description?.trim() || '',
        ...this.toDto(),
      } as RequestItem,
      units: this.units,
      totalDiscount: this.totalDiscount,
      totalPriceWithTax: Math.round((this.totalPrice - this.totalDiscount) * 100) / 100,
    };
  }
}
